export default __webpack_public_path__ + "static/feature-flag-to-control-sessions-dark-mode-f96248ebd4f4dc1540d3547580d25f54.png";